import React from "react"
import { useParams } from "react-router-dom"

import { callCounselApi } from "@shared/apis"
import { useLayerPopupContext } from "@shared/contexts"

function SignUp() {
  const { open, close, alert } = useLayerPopupContext()
  const { scheduleId } = useParams<{ scheduleId?: string }>()

  const handleCallCounsel = () => {
    callCounselApi
      .post(scheduleId)
      .then((res) => {
        handleAlertPopup("가입 상담신청이 완료되었습니다.")
      })
      .catch((err) => {
        handleAlertPopup("에러가 발생하였습니다. 관리자에게 문의해주세요")
      })
  }

  const handleAlertPopup = (message: string) => {
    alert.handleAlert({ contents: message })
    open("ALERT")
  }

  return (
    <React.Fragment>
      <article className="popup" style={{ margin: "-150px 0 0 -250px" }}>
        <div className="titB">
          <h1>고객센터 가입문의</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <p>가입문의 전화상담을 요청하시겠습니까?</p>
          </div>
          <p className="txt">
            ※ 가입문의를 요청하시면 접수하신 순서대로 업무시간에 상담
            <br />
            전화를 드립니다.
          </p>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="요청"
            onClick={(e) => {
              e.preventDefault()
              handleCallCounsel()
            }}
          >
            요청
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default SignUp
